import { Controller } from "@hotwired/stimulus"

// Toggles the right sidebar (sites + custom reports) on the customer show
// page. State persists per browser via localStorage.
export default class extends Controller {
  static targets = ["expanded", "collapsed"]

  connect() {
    this.applyState(this.readStoredState())
  }

  toggle() {
    const collapsed = !this.expandedTarget.classList.contains("hidden")
    this.applyState(collapsed)
    this.writeStoredState(collapsed)
  }

  applyState(collapsed) {
    if (this.hasExpandedTarget) {
      this.expandedTarget.classList.toggle("hidden", collapsed)
    }
    if (this.hasCollapsedTarget) {
      this.collapsedTarget.classList.toggle("hidden", !collapsed)
    }
  }

  readStoredState() {
    try {
      return window.localStorage.getItem(this.storageKey) === "1"
    } catch {
      return false
    }
  }

  writeStoredState(collapsed) {
    try {
      if (collapsed) {
        window.localStorage.setItem(this.storageKey, "1")
      } else {
        window.localStorage.removeItem(this.storageKey)
      }
    } catch {
      // Ignore storage errors (private mode, quota, etc.)
    }
  }

  get storageKey() {
    return "customers:sidebar:collapsed"
  }
}
